import React from 'react'
import _ from 'lodash'
import {lifecycle} from 'recompose'
import getUrl from "../../../../getUrl";
import getImgUrl from "../../../../getImgUrl";
import Loader from "../../../../basic/LoaderCircle";
import Image from '../../../../basic/image'
import * as media from '../../../../media'
import styled from 'styled-components'
import {browserHistory} from 'react-router'
import Text from '../../../../text'

const LessThan700Check = styled.div`
  ${media.smallerThan(700)`display:none;`}
`

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  ${media.smallerThan(700)`justify-content: center;`}
`

// TODO_translate: не нашли кейс, где используется этот компонент
function CategoryNew(props) {
  const {list, loading} = props
  return (
    <div>
      {loading && <Loader/>}
      {!loading && list && list.length > 0 &&
      <div style={{fontSize: '24px', marginTop: 40, marginBottom: 40, fontWeight: 800}}>
        <Text id={'new_title'}/>
      </div>}
      <Container>
        {!loading && (list || []).map(e => {
          const imgUrl = e.image_list.split(',')[0]
          return (
            <LessThan700Check
              style={{
                padding: '25px',
                background: 'rgb(242, 244, 245)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                marginRight: 15,
                cursor: 'pointer',
                height: 380,
                minWidth: '22%',
                maxWidth: 300,
                textAlign: 'center',
              }}
              onClick={() => {
                browserHistory.push(`/item/${e.id}`)
              }}
            >
              {
                imgUrl &&
                <Image
                  src={getImgUrl(`/media/static/product_photos/${imgUrl}`)}
                  className="cover-image"
                  style={{
                    maxHeight: 200,
                    maxWidth: '100%',
                  }}
                />
              }
              <div style={{marginTop: 25, fontSize: 18,}}>{e.article}</div>
              <div style={{fontWeight: 800, marginTop: 10, fontSize: 16,}}>{e.display_name}</div>
              <div style={{fontSize: 16}}>{e.type_name}</div>
            </LessThan700Check>
          )
        })}
      </Container>
    </div>
  )
}

export default lifecycle({
  state: {loading: true},
  componentDidMount() {
    if (_.isArray(this.props.type)) {
      Promise.all(this.props.type.map(t => {
        return fetch(getUrl(`/cat/v1/item?limit=10&order={"create_date":"desc"}&is_new=true&type_id=${this.props.type}`)).then(data => {
          return data.json()
        }).catch(err => {
          console.log(err)
        })
      }))
        .then(results => {
          const list = results.reduce((r, e) => [...r, ..._.get(e, 'data.data')], [])
          this.setState({list, loading: false})
        })
    } else {
      fetch(getUrl(`/cat/v1/item?limit=10&order={"create_date":"desc"}&is_new=true&type_id=${this.props.type}`)).then(data => {
        return data.json()
      }).then(listItems => {
        const list = _.get(listItems, 'data.data')
        this.setState({list, loading: false})
      }).catch(err => {
        console.log(err)
      })
    }
  }
})(CategoryNew)



// WEBPACK FOOTER //
// ./src/finwhale/common/category/new/index.js